import React from "react";

import Loader from "../loader/login-loader"; // Import reusable Loader component

import styles from "./styles.module.css";

const SummaryLoader: React.FC = () => {
    return (
        <div className={styles.summaryLoader}>
            <Loader wrapperClassName={styles.customWrapper} />
            <div className={styles.textWrapper}>
                <h2 className={styles.text}>Generating your customized summary...</h2>
                <p className={styles.subText}>This may take a minute.</p>
                <p className={styles.subText}>Feel free to explore other sections in the meantime.</p>
            </div>
        </div>
    );
};

export default SummaryLoader;
